import { handleActions, combineActions } from 'redux-actions';
import * as actions from '../../Actions/analytics';

export interface AnalyticsState {
  isFetching: boolean;
}

export const initialState: AnalyticsState = {
  isFetching: true,
};

const analytics = handleActions(
  {
    [combineActions(
      actions.loadAnalytics,
      actions.analyticsLoaded,
    ) as any]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
  initialState,
);

export default analytics;



// WEBPACK FOOTER //
// ./src/redux/reducers/analytics.ts